export default {"src":"/hub/_next/static/media/mag-glass-icon.74e79b1e.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};